/**
 * Component to render SBA Enterprise award page
 */
const EnterpriseAward = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="enterprise-award-component"
    >
      <p>
        <strong>Award Criteria</strong>
      </p>

      <p>
        This award is open to all enterprises in Singapore. The criteria for the
        Enterprise Award are categorised into four areas:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Innovation</li>
        <li>Financial Performance/Productivity</li>
        <li>Company Management</li>
        <li>Contribution to the Community</li>
      </ul>

      <p>
        <strong>Innovation</strong>
      </p>

      <p>
        The success of the company in innovation of either products, services or
        new markets. Particular attention will be focussed on the company&apos;s
        penetration of overseas markets drawing on enterprise and expertise of
        its Singapore base.
      </p>

      <p>
        <strong>Financial Performance/Productivity</strong>
      </p>

      <p>
        The company must have an outstanding and sustained growth in profit. The
        age of a company will be taken into consideration in relation to profit
        track record.
        <br />
        The company must have taken positive steps and made conscious efforts
        towards improving its productivity level.
      </p>

      <p>
        <strong>Company Management</strong>
      </p>

      <p>
        The organisation must display an effective management style and have a
        viable organisational structure. The company must have a track record of
        establishing and maintaining harmonious relations within the
        organisation and set examples for the industry it is in.
      </p>

      <p>
        <strong>Contribution to the Community</strong>
      </p>

      <p>
        The company&apos;s contribution to the community will be considered
        favourably.
      </p>
    </div>
  );
};

export default EnterpriseAward;
